import { render } from "./ConclusionRow.vue?vue&type=template&id=4042bf0c&scoped=true"
import script from "./ConclusionRow.vue?vue&type=script&lang=js"
export * from "./ConclusionRow.vue?vue&type=script&lang=js"

import "./ConclusionRow.vue?vue&type=style&index=0&id=4042bf0c&scoped=true&lang=css"

import exportComponent from "/var/www/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4042bf0c"]])

export default __exports__